import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';

export default function LanguageSwitcher({ variant = 'default', onSelect }) {
  const { lang, languages, getSwitchUrl } = useLanguage();

  if (variant === 'menu') {
    return (
      <div className="flex items-center bg-[#f2ede4] p-1.5 rounded-xl border border-stone-300 shadow-sm">
        {languages.map((l) => {
          const isActive = lang === l.code;
          const targetUrl = getSwitchUrl(l.code);

          return (
            <Link
              key={l.code}
              to={targetUrl}
              onClick={onSelect}
              className={`flex items-center justify-center px-4 py-2 rounded-lg text-xs font-bold tracking-wider uppercase transition-all duration-300 ${
                isActive
                  ? 'bg-[#581c24] text-white shadow-sm'
                  : 'text-stone-700 hover:text-[#581c24] hover:bg-stone-200/50'
              }`}
              aria-label={`Skift til ${l.label} (${l.shortLabel})`}
            >
              <span>{l.shortLabel}</span>
            </Link>
          );
        })}
      </div>
    );
  }

  if (variant === 'footer') {
    return (
      <div className="inline-flex items-center bg-[#170e10] p-1 rounded-xl border border-[#3d272b]">
        {languages.map((l) => {
          const isActive = lang === l.code;
          const targetUrl = getSwitchUrl(l.code);

          return (
            <Link
              key={l.code}
              to={targetUrl}
              onClick={onSelect}
              className={`flex items-center justify-center px-3 py-1.5 rounded-lg text-xs font-bold tracking-wider uppercase transition-all duration-300 ${
                isActive
                  ? 'bg-[#581c24] text-white'
                  : 'text-stone-400 hover:text-white hover:bg-stone-800/40'
              }`}
              aria-label={`Skift til ${l.label} (${l.shortLabel})`}
            >
              <span>{l.shortLabel}</span>
            </Link>
          );
        })}
      </div>
    );
  }

  // Default compact toggle for navbar and pages
  return (
    <div 
      className="inline-flex items-center bg-stone-100/90 p-1 rounded-xl border border-stone-300/80 shadow-xs"
      role="group"
      aria-label="Vælg sprog / Select language"
    >
      {languages.map((l) => {
        const isActive = lang === l.code;
        const targetUrl = getSwitchUrl(l.code);

        return (
          <Link
            key={l.code}
            to={targetUrl}
            onClick={onSelect}
            className={`flex items-center justify-center px-3 py-1 rounded-lg text-[11px] font-bold tracking-wider uppercase transition-all duration-300 ${
              isActive
                ? 'bg-[#581c24] text-white shadow-xs'
                : 'text-stone-700 hover:text-[#581c24] hover:bg-stone-200/60'
            }`}
            aria-label={`Vælg ${l.label} (${l.shortLabel})`}
          >
            <span>{l.shortLabel}</span>
          </Link>
        );
      })}
    </div>
  );
}
